export const AI_OUTPUT_DISCLAIMER_TEXT =
    "この内容はAIが生成・提案しており、誤りが含まれる可能性があります。利用前に内容をご確認ください。AIが生成した内容について、REECHは責任を負いません。";
